import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      // 映射 store 中的核心状态
      usToken: 'usToken',
      myUserInfo: 'myUserInfo',
      activityInfo: 'activityInfo',
      projectInfo: 'projectInfo',
      // 提供便捷别名 (兼容部分页面习惯)
      userInfo: 'myUserInfo'
    })
  }
}
